<avi-data-grid
    [config]="oobDsRequestLogGridConfig"
    [rows]="oobDsRequestLogs$ | async"
></avi-data-grid>

<ng-template
    #dsNameFieldTemplateRef
    let-row
>
    <ng-container *ngIf="row.ds_name as dsName; else na">
        <span
            logFilter
            property="oob_log.ds_req_logs.ds_name"
            (onFilterAdd)="logCinematicStore.closeCinematic()"
            [value]="dsName"
        >
            {{ dsName }}
        </span>
    </ng-container>
</ng-template>

<ng-template
    #vsDsEventFieldTemplateRef
    let-row
>
    <ng-container *ngIf="row.event as dsEvent; else na">
        <span
            logFilter
            property="oob_log.ds_req_logs.event"
            [value]="dsEvent"
            (onFilterAdd)="logCinematicStore.closeCinematic()"
        >
            {{ dsEvent }}
        </span>
    </ng-container>
</ng-template>

<ng-template
    #expandedContentTemplateRef
    let-row
>
    <div class="log-cinematic-section-out-of-band__grid-expanded-content">
        <!-- Summary -->
        <div class="log-cinematic-section-out-of-band__grid-expanded-content-section">
            <!-- left column -->
            <div logCinematicSectionColumn>
                <h5 class="log-cinematic-section__column-title">
                    {{ globalL10nKeys.summaryLabel | vtranslate }}
                </h5>
                <span logFieldTitle>{{ globalL10nKeys.poolNameLabel | vtranslate }}</span>
                <ng-container *ngIf="row.pool_name?.val as poolName; else na">
                    <span
                        logFilter
                        property="oob_log.ds_req_logs.pool_name"
                        [value]="poolName"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ poolName }}
                    </span>
                </ng-container>

                <span logFieldTitle>{{ globalL10nKeys.sourcePortLabel | vtranslate }}</span>
                <ng-container *ngIf="row.source_port !== undefined; else na">
                    <span
                        logFilter
                        property="oob_log.ds_req_logs.source_port"
                        [value]="row.source_port"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ row.source_port }}
                    </span>
                </ng-container>
                <span logFieldTitle>{{ globalL10nKeys.totalTimeLabel | vtranslate }}</span>
                <ng-container *ngIf="row.total_time !== undefined; else na">
                    <span
                        logFilterList
                        property="oob_log.ds_req_logs.total_time"
                        [value]="row.total_time"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ row.total_time }}
                    </span>
                    {{ globalL10nKeys.msLabel | vtranslate }}
                </ng-container>
            </div>

            <!-- right column -->
            <div
                logCinematicSectionColumn
                [withDivider]="false"
            >
                <span
                    logFieldTitle
                    [withMarginTop]="false"
                >
                    {{ globalL10nKeys.serverNameLabel | vtranslate }}
                </span>
                <ng-container *ngIf="row.server_name as serverName; else na">
                    <span
                        logFilter
                        property="oob_log.ds_req_logs.server_name"
                        [value]="serverName"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ serverName }}
                    </span>
                </ng-container>

                <span logFieldTitle>
                    {{ globalL10nKeys.serverIpLabel | vtranslate }}:{{ globalL10nKeys.portLabel | vtranslate }}
                </span>
                <ng-container *ngIf="row.server_ip !== undefined; else na">
                    <span
                        logFilter
                    >
                        {{ row.server_ip }}
                    </span>
                    <ng-container *ngIf="row.source_port !== undefined">
                        :<span
                            logFilter
                            property="oob_log.ds_req_logs.source_port"
                            [value]="row.source_port"
                            (onFilterAdd)="logCinematicStore.closeCinematic()"
                        >
                            {{ row.source_port }}
                        </span>
                    </ng-container>
                </ng-container>

                <span logFieldTitle>{{ globalL10nKeys.serversTriedLabel | vtranslate }}</span>
                <ng-container *ngIf="row.servers_tried !== undefined; else na">
                    <span
                        logFilterList
                        property="oob_log.ds_req_logs.servers_tried"
                        [value]="row.servers_tried"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ row.servers_tried }}
                    </span>
                </ng-container>
            </div>
        </div>

        <!-- Request / Response -->
        <div class="log-cinematic-section-out-of-band__grid-expanded-content-section">
            <!-- left column -->
            <div logCinematicSectionColumn>
                <h5 class="log-cinematic-section__column-title">
                    {{ globalL10nKeys.requestLabel | vtranslate }}
                </h5>
                <span logFieldTitle>{{ globalL10nKeys.httpMethodLabel | vtranslate }}</span>
                <ng-container *ngIf="row.method as httpMethod; else na">
                    <span
                        logFilter
                        property="oob_log.ds_req_logs.method"
                        [value]="httpMethod"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ httpMethod }}
                    </span>
                </ng-container>

                <span logFieldTitle>{{ globalL10nKeys.httpVersionLabel | vtranslate }}</span>
                <ng-container *ngIf="row.http_version?.val as httpVersion; else na">
                    <span
                        logFilter
                        property="oob_log.ds_req_logs.http_version"
                        [value]="httpVersion"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ httpVersion }}
                    </span>
                </ng-container>

                <span logFieldTitle>{{ globalL10nKeys.uriPathLabel | vtranslate }}</span>
                <ng-container *ngIf="row.uri_path as uriPath; else na">
                    <span
                        logFilter
                        property="oob_log.ds_req_logs.uri_path"
                        [value]="uriPath"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ uriPath }}
                    </span>
                </ng-container>

                <span logFieldTitle>{{ l10nKeys.uriQueryLabel | vtranslate }}</span>
                <ng-container *ngIf="row.uri_query as uriQuery; else na">
                    <span
                        logFilter
                        property="oob_log.ds_req_logs.uri_query"
                        [value]="uriQuery"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ uriQuery }}
                    </span>
                </ng-container>

                <span logFieldTitle>{{ globalL10nKeys.requestLengthLabel | vtranslate }}</span>
                <ng-container *ngIf="row.request_length !== undefined; else na">
                    <span
                        logFilterList
                        property="oob_log.ds_req_logs.request_length"
                        [value]="row.request_length"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ row.request_length }}
                    </span>
                    {{ globalL10nKeys.lowerCaseBytesLabel }}
                </ng-container>
            </div>

            <!-- right column -->
            <div
                logCinematicSectionColumn
                [withDivider]="false"
                class="log-cinematic-section-out-of-band__response-column"
            >
                <h5
                    class="log-cinematic-section__column-title log-cinematic-section-out-of-band__grid-expanded-content-response-title"
                >
                    {{ globalL10nKeys.responseLabel | vtranslate }}
                </h5>

                <span
                    logFieldTitle
                >
                    {{ l10nKeys.httpResponseCodeLabel | vtranslate }}
                </span>
                <ng-container *ngIf="row.http_response_code !== undefined; else na">
                    <span
                        logFilter
                        property="oob_log.ds_req_logs.http_response_code"
                        [value]="row.http_response_code"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ row.http_response_code }}
                    </span>
                </ng-container>

                <span logFieldTitle>{{ globalL10nKeys.responseLengthLabel | vtranslate }}</span>
                <ng-container *ngIf="row.response_length !== undefined; else na">
                    <span
                        logFilterList
                        property="oob_log.ds_req_logs.response_length"
                        [value]="row.response_length"
                        (onFilterAdd)="logCinematicStore.closeCinematic()"
                    >
                        {{ row.response_length }}
                    </span>
                </ng-container>
            </div>
        </div>

        <!-- Headers -->
        <div class="log-cinematic-section-out-of-band__grid-expanded-content-section">
            <div logCinematicSectionColumn>
                <h5 class="log-cinematic-section__column-title">
                    {{ l10nKeys.dsHeaders | vtranslate }}
                </h5>
                <avi-diff-grid
                    [config]="headersDiffGridConfig"
                    [rows]="row | subLogHeadersDiffSourcePair : 'headers_sent_to_server' : 'headers_received_from_server' | aviDiffGridRows"
                ></avi-diff-grid>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #na>
    <span logEmptyField></span>
</ng-template>
